import Vue from 'vue';
import * as nodes from "@/nodes";

export default new Vue({
    data() {
        return {
            geofences: [],
            nextGeofenceId: 0
        };
    },
    computed: {
        allGeofences() { return this.geofences; },
        templateGeofences() { return this.geofences.filter(geofence => geofence.kind == 'template'); },
        regularGeofences() { return this.geofences.filter(geofence => geofence.kind == 'regular'); },
        fragmentGeofences() { return this.geofences.filter(geofence => geofence.kind == 'fragment'); }
    },
    methods: {
        findGeofence(id) {
            let candidates = this.geofences.filter(geofence => geofence.id == id);

            if (candidates.length != 1) return null;

            return candidates[0];
        },
        addGeofence(options = {}) {
            const geofenceDefaults = {
                id: this.nextGeofenceId++, 
                name: "",
                kind: "regular",
                root: new nodes.Root(),
                template: null
            };

            let geofence = Object.assign({}, geofenceDefaults, options);

            this.geofences.push(geofence);

            return geofence;
        }
    }
});
